<template>
<div id="locations-edit" v-if="locationDataModel">
    <div class="con-vs-alert mt-1 con-vs-alert-danger" v-if="locationDataModel.permissions && locationDataModel.permissions.edit === false">
        <div class="vs-alert vs-alert px-3 py-2">
            <p class="text-xs whitespace-pre-line">Sorry, you do not have permission to edit this location</p>
        </div>
    </div>
    <section v-else>
        <div class="vx-row" v-if="isArchivedLocation">
            <div class="vx-col w-full mb-4">
                <vs-button color="#D4D4D4" type="filled" size="small">Archived</vs-button>
                <span class="ml-4 text-lg font-semibold tracking-wide">You cant'edit or check into/out of an archived location.</span>
                <span class="ml-3 text-lg font-semibold tracking-normal text-link text-primary cursor-pointer" @click="restoreLocation">Restore</span>
            </div>
        </div>
        <FormLocation ref="form" :data="locationDataModel" @success="onSuccess" :isArchivedLocation="isArchivedLocation" />
        <Advertise :data="locationDataModel" :isArchivedLocation="isArchivedLocation" />
        <ContactTypes :location="locationDataModel" @success="onSuccess" :isArchivedLocation="isArchivedLocation" />
        <div class=" py-1 flex justify-between ">
            <vs-button color="danger" type="border" class="mr-auto mt-3 vx-row__actions" @click.prevent="activePrompt = true" icon-pack="feather" icon="icon-archive" icon-before :disabled="isArchivedLocation">Archive Location</vs-button>
        </div>

    </section>
    <vs-prompt @accept="archiveLocation" @cancel="closePrompt" @close="closePrompt" :active="activePrompt" title="Confirm Location Archive" acceptText="Archive" color="danger">
        <p>Are you sure you want to Archive location  <span class="font-semibold">{{locationDataModel.name}}</span>?  This action <span class="font-semibold">cannot be undone</span>.</p>
    </vs-prompt>

</div>
</template>

<script>
import FormLocation from './components/FormLocation';
import ContactTypes from './components/ContactTypes';
import Advertise from './components/Advertise';
import Settings from './components/Settings';
import {
    mapState
} from 'vuex';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

export default {
    components: {
        FormLocation,
        ContactTypes,
        Advertise,
        Settings
    },
    data() {
        return {
            locationDataModel: null,
            confirmDelete: '',
            activePrompt: false
        };
    },
    computed: {
        ...mapState('visitManagement', ['location']),
        isFormChanged() {
            return !isEqual(this.location, this.locationDataModel);
        },
        isArchivedLocation() {
            const { entity } = this.locationDataModel;
            const hasDateDeleted = (entity || {}).dateDeleted || null;
            return hasDateDeleted !== null;
        }
    },
    methods: {
        onSuccess(data) {
            console.log('SUCCESS', data)
            this.locationDataModel = cloneDeep(data);
        },
        archiveLocation() {
            const data = this.locationDataModel;
            this.$store
                .dispatch('visitManagement/archiveLocation', data.id)
                .then(res => {
                    this.closePrompt();
                    this.$emit('success', res.data)
                    this.$router.push({
                        name: 'locations'
                    })
                    this.$vs.notify({
                        color: 'success',
                        title: 'Location Archived'
                    });

                    console.log(res);
                });
        },
        closePrompt() {
            this.confirmDelete = '';
            this.activePrompt = false;
        },
        async restoreLocation() {
            const data = this.locationDataModel;
            await this.$store
                    .dispatch('visitManagement/restoreLocation', data.id)
                    .then(async res => {
                        await this.fetchLocation();
                        this.$vs.notify({
                            color: 'success',
                            title: 'Location Restored',
                            fixed: true
                        });
                    })
        },
        async fetchLocation() {
            const result = await this.$store.dispatch(
                'visitManagement/fetchLocation',
                this.$route.params.id
            );
            this.locationDataModel = cloneDeep(result);
            console.log("this.locationDataModel >>> ", this.locationDataModel);
        }
    },
    async created() {
        await this.fetchLocation();
    },
    beforeRouteLeave(to, from, next) {
        this.$nextTick(() => {
            const {
                isFormChanged,
                $vs
            } = this;
            if (isFormChanged) {
                $vs.dialog({
                    type: 'confirm',
                    title: 'Unsaved changes',
                    text: 'You have unsaved changes. Do you want to leave the page without saving?',
                    acceptText: 'Yes, Leave',
                    accept: () => next(),
                    cancel: () => next(false)
                })
            } else {
                next();
            }
        })
    }
};
</script>

<style lang="scss" scoped>
@media print {}
</style>
